import './index.erb';
import './index.rb';
import zaraz from 'utils/trackers/zaraz';

(() => {
  'use strict';

  const $container = $('[data-event]');
  const eventData = $container.data('event') || {};

  if ($container && eventData?.active) {
    zaraz.set('show_experiment', 'true', { scope: 'persist' });
    zaraz.track(eventData.event, eventData.event_props);
  }
})();
